import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() overrideUrl?: string;

  constructor(private location: Location, private router: Router) {
    addIcons({ arrowBackOutline });
  }

  goBack(): void {
    if (this.overrideUrl) {
      this.router.navigateByUrl(this.overrideUrl);
      return;
    }

    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
